import getVisitorId from 'mex_components/app/scripts/storage/getVisitorId';
import getClientId from 'mex_components/app/scripts/storage/getClientId';


const linkSelectionTracker = (link) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'buybox_radioButton',
    link_text: link.innerText,
    visitor_id: getVisitorId(),
    client_id: getClientId()
  });
};


export default function(el){
  var label = document.querySelector('label[for=' + el.id + ']');
  var links = label.querySelectorAll('button');
  links.forEach(link => {
    link.addEventListener('click', () => linkSelectionTracker(link));
  });
}
